import { Component, EventEmitter, Input, Output } from '@angular/core';
import { toExcelFormat } from 'src/app/helpers/format-position';

@Component({
  selector: 'app-setup-ground-pigeonhole-positions-list',
  templateUrl: './setup-ground-pigeonhole-positions-list.component.html',
  styleUrls: ['./setup-ground-pigeonhole-positions-list.component.scss']
})
export class SetupGroundPigeonholePositionsListComponent {

  @Input() positions = [];
  @Input() loading = false;
  @Output() positionClick = new EventEmitter<any>();
  @Output() goBack = new EventEmitter<void>();

  getCoordinates(position) {
    if (!position) {
      return '---';
    }

    if (position.x !== undefined && position.y !== undefined) {
      return toExcelFormat(position.x, position.y);
    }

    if (position.column !== undefined && position.row !== undefined) {
      return toExcelFormat(position.column, position.row);
    }

    return '---';
  }

  getPositionLabel(position) {
    return position?.alias || '---';
  }

  emitPositionClick(position) {
    if (this.loading) {
      return;
    }
    this.positionClick.emit(position);
  }

  emitGoBack() {
    this.goBack.emit();
  }
}
